import { render, staticRenderFns } from "./New.vue?vue&type=template&id=6ffea81e"
import script from "./New.vue?vue&type=script&setup=true&lang=ts"
export * from "./New.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./New.vue?vue&type=style&index=0&id=6ffea81e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports